import BasicRouterView from "../../../components/BasicRouterView.vue";

const adminMultpex = {
  path: "admtx",
  redirect: { name: "salvos" },
  meta: {
    label: "Admin Multpex",
    icon: "admin_panel_settings",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "admin-multpex/admin-multpex-postos",
      name: "admin-multpex-postos",
      meta: {
        label: "UNIDADES",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../adminMultpex/views/Postos.vue"
        ),
    },
    {
      path: "admin-multpex/admin-multpex-maquina",
      name: "admin-multpex-maquina",
      meta: {
        label: "Maquinas",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../adminMultpex/views/Maquinas.vue"
        ),
    },
    {
      path: "admin-multpex/admin-multpex-permissao",
      name: "admin-multpex-permissao",
      meta: {
        label: "Permissão",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../adminMultpex/views/Permissao.vue"
        ),
    },
    {
      path: "admin-multpex/admin-multpex-gestao",
      name: "admin-multpex-gestao",
      meta: {
        label: "Gestão Menus",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../adminMultpex/views/Gestao.vue"
        ),
    },
    {
      path: "admin-multpex/admin-multpex-alertas",
      name: "admin-multpex-alertas",
      meta: {
        label: "Alertas Usuarios",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../adminMultpex/views/Alertas.vue"
        ),
    },
  ],
};

export default adminMultpex;
